import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Modal } from 'lego-dist';
import LoadingBar from './LoadingBar';

interface IModalLoadingFeedback {
  maxWaitingSeconds?: number;
  isLoading: boolean;
  title?: string;
}

const LoadingTitle = styled.p`
  margin: 30px 10px 10px 10px;
  font-size: 20px;
  font-weight: bold;
  color: #4A4A4A;
  letter-spacing: 0;
  text-align: center;
  line-height: 21px;
`;

const ModalLoadingFeedback: React.FC<IModalLoadingFeedback> = ({
  maxWaitingSeconds = 5,
  isLoading,
  title = 'common:LOADING',
}) => {
  const [waitingTime, setWaitingTime] = useState(0);
  const { t } = useTranslation();


  useEffect(() => {
    let counter: any = () => {};
    if (isLoading) {
      counter = setInterval(() => {
        setWaitingTime(time => time + 1);
      }, 1000);
    } else {
      clearInterval(counter);
      setWaitingTime(0);
    }

    return () => clearInterval(counter);
  }, [isLoading]);

  return (
    <Modal
      openModal={isLoading && waitingTime >= maxWaitingSeconds}
      showCloseButton={false}
      closeOnBackdrop={false}
      className="modal-loading-feedback"
    >
      {() => (
        <div>
          <LoadingTitle>{t(title)}</LoadingTitle>
          <LoadingBar />
        </div>
      )}
    </Modal>
  );
};

export default ModalLoadingFeedback;
